export default __webpack_public_path__ + "static/media/01__o_preview_1.25376742.jpg";